import ReducerRegistry from '../base/redux/ReducerRegistry';
import * as TegoServerActionTypes from './actionTypes';
const initialState = {
    isEnabled: false
};
const tegoServerReducer = (state = initialState, action) => {
    switch (action.type) {
        case TegoServerActionTypes.INIT_CONFIG_SUCCESS:
            return {
                isEnabled: true,
                urls: action.payload.urls
            };
        default:
            return state;
    }
};
ReducerRegistry.register('features/tego-server', tegoServerReducer);
